export default class ClientFilter {
  static include = ['orders'];
}
